/**
 * What a fault on OUR side reads as (A-55 / A-61, usability sweep).
 *
 * A 500 reached the screen as the toast "Internal server error", and a gateway
 * page as "Request failed with status code 502": engineering text that tells a
 * manager nothing, and reads as if they had done something wrong. Both now say
 * it is on our side and who can fix it.
 *
 * Only STOCK text is replaced. The API's exception filter reserves "Internal
 * server error" for an actual fault (status >= 500, or nothing better to say), so
 * it carries no information; a 5xx whose service wrote a real sentence keeps it.
 *
 * Deliberately does not open with "Something went wrong" / "Failed to": the toast
 * layer (~/lib/toast) treats that boilerplate as generic and lets a more specific
 * toast replace it, and this IS the specific one.
 */
export const SERVER_FAULT_MESSAGE =
  "That's a problem on our side, not something you did. Try again in a few minutes. If it keeps happening, contact Palate support.";

/** The text a 5xx carries when nothing wrote a sentence for it. */
const STOCK_SERVER_MESSAGE =
  /^(internal server error|bad gateway|service unavailable|gateway timeout|request failed with status code 5\d\d)\.?$/i;

export function isStockServerMessage(message: string): boolean {
  return STOCK_SERVER_MESSAGE.test(message.trim());
}

/** `message`, or the plain sentence when it is a 5xx's stock text. */
export function plainServerFaultMessage(
  message: string,
  status: number | undefined,
): string {
  const isServerFault = status !== undefined && status >= 500 && status < 600;
  return isServerFault && isStockServerMessage(message) ? SERVER_FAULT_MESSAGE : message;
}
